module.exports = __webpack_public_path__ + "static/img/icon-s.6b5c8fdd.png";